export default "__VITE_ASSET__a1dc3f8d__"